/**
 * Created by slava on 24.03.17.
 */

const TacticalExtendWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        const styles = cleverapps.styles.TacticalExtendWindow;

        const animation = this.createAnimation();

        const text = this.createText();

        const content = new cleverapps.Layout([text, animation], {
            margin: styles.margin,
            direction: cleverapps.UI.VERTICAL
        });

        this._super({
            title: Messages.get("TacticalExtendWindow.title"),
            name: "tacticalextendwindow",
            content,
            button: {
                width: styles.button.width,
                height: styles.button.height,
                text: `$$${TacticalExtendWindow.PRICE}`,
                onPressed: this.onPressed.bind(this)
            }
        });
    },

    getPerson: function () {
        return "hero";
    },

    createText: function () {
        const styles = cleverapps.styles.TacticalExtendWindow;

        const text = cleverapps.UI.generateOnlyText(Messages.get("TacticalExtendWindow.text", {
            amount: TacticalExtendWindow.AMOUNT
        }), cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setDimensions(styles.text.width, 0);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_CENTER);

        return text;
    },

    createAnimation: function () {
        const styles = cleverapps.styles.TacticalExtendWindow;

        const node = new cc.Node();
        node.setAnchorPoint(0.5, 0.5);
        node.setContentSize2(styles.animation);

        const animation = new cleverapps.Spine(bundles.tactical_extend_window.jsons.tactical_extend);
        animation.setSkin(cleverapps.config.name);
        animation.setAnimation(0, "addmoves", true);
        node.addChild(animation);
        animation.setAlignment(styles.animation);

        return node;
    },

    onPressed: function () {
        if (!Game.currentGame) {
            this.close();

            return;
        }

        if (cleverapps.user.spendHard(cleverapps.EVENTS.SPENT.TACTICAL_EXTEND, TacticalExtendWindow.PRICE)) {
            this.giveMoves();

            this.close();
        }
    },

    giveMoves: function () {
        const moves = cleverapps.UI.generateImageText(TacticalExtendWindow.AMOUNT, cleverapps.styles.FONTS.MOVES_TEXT);
        moves.setAlignment(this.buttons);
        this.buttons.parent.addChild(moves);

        moves.runAction(new cc.Sequence(
            cleverapps.effects.fireAction("ui.shop.buy"),
            StandartAnimations.animateCollect(moves, "moves", {
                duration: 0.7,
                scale: 1.5,
                collectEffect: true
            }),
            new cc.RemoveSelf()
        ));

        Game.currentGame.counter.setTimeout(() => {
            Game.currentGame.setMoves(Game.currentGame.moves + TacticalExtendWindow.AMOUNT);
        }, 700);
    },

    listBundles: function () {
        const bundles = ["tactical_extend_window"];

        if (cleverapps.config.rpg) {
            bundles.push("dialogues");
        }

        return bundles;
    }
});

TacticalExtendWindow.canShow = function () {
    if (!cleverapps.user.checkAvailable(cleverapps.config.availables.TACTICAL_EXTEND_WINDOW)) {
        return false;
    }

    if (!levels.user.canTakeHard(TacticalExtendWindow.PRICE)) {
        return false;
    }

    const lastTime = cleverapps.dataLoader.load(DataLoader.TYPES.BUY_MOVES_WINDOW) || 0;

    return Date.now() - lastTime > cleverapps.parseInterval(TacticalExtendWindow.INTERVAL) && Math.random() < TacticalExtendWindow.PROBABILITY;
};

TacticalExtendWindow.show = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.BUY_MOVES_WINDOW, Date.now());

    cleverapps.metrics.logEvent(cleverapps.EVENTS.TACTICAL_EXTEND_SHOW);

    return new TacticalExtendWindow();
};

TacticalExtendWindow.PROBABILITY = 0.12;
TacticalExtendWindow.PRICE = 50;
TacticalExtendWindow.AMOUNT = 3;
TacticalExtendWindow.INTERVAL = "1 hour";

if (cleverapps.config.debugMode) {
    TacticalExtendWindow.INTERVAL = "1 minute";
}

cleverapps.styles.TacticalExtendWindow = {
    margin: 30,

    text: {
        width: 500
    },

    animation: {
        width: 300,
        height: 300,

        x: { align: "center" },
        y: { align: "center" }
    },

    button: {
        width: 320,
        height: 120
    }
};
